export default __webpack_public_path__ + "static/media/mobilehuddle.104e4ac4.png";